export const containsUnprintableOrControlCharacters = (candidateString: string) => {
	// \p{Cc} matches control characters
	// \p{Cf} matches format characters (e.g., zero-width space)
	// \p{Cn} matches unassigned code points
	// \p{Cs} matches surrogate code points
	return /[\p{Cc}\p{Cf}\p{Cn}\p{Cs}]/u.test(candidateString);
};
